<template>
    <div class="edit-building-type">
        <div class="edit-building-type__grid">
            <div 
                v-for="type in buildingTypes"
                :key="type.id"
                class="edit-building-type__card"
                :class="{ 'edit-building-type__card--selected': type.id === building.type_id }"
                @click="building.type_id = type.id"
                role="button"
                tabindex="0"
                @keydown.enter="building.type_id = type.id"
                @keydown.space.prevent="building.type_id = type.id"
                :aria-label="`Select ${type.type} building type`"
                :aria-pressed="type.id === building.type_id"
            >
                <span 
                    class="edit-building-type__label"
                    :class="{ 'edit-building-type__label--selected': type.id === building.type_id }"
                >
                    {{ type.type }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EditBuildingType',

        props: {
            buildingData: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                building: this.buildingData,
                buildingTypes: []
            }
        },

        mounted() {
            this.initBuildingTypes();
        },

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types')
                    .then((response) => {
                        this.buildingTypes = response.data.types;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    }
</script>
